import { Helmet } from "react-helmet";
import { useState, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  FaChevronLeft,
  FaClock,
  FaCircleCheck,
  FaSpinner,
  FaCirclePause,
  FaCircleXmark,
  FaFire,
  FaPenToSquare,
  FaTrashCan,
  FaArrowUpWideShort,
  FaUser,
  FaCalendarDays,
  FaHashtag,
  FaBuilding,
  FaFlag,
  FaCircleInfo,
  FaCommentDots,
  FaPaperclip,
  FaTimeline,
  FaListCheck,
  FaShareFromSquare,
  FaRotateLeft,
  FaCirclePlay,
  FaSquareCheck,
  FaBan,
  FaBell,
  FaEllipsisVertical,
  FaChevronDown,
} from "react-icons/fa6";
import { DashboardLayout } from "../../../../components/layouts/DashboardLayout";
import { Header } from "../../../../components/Header";
import { BtnDefault } from "../../../../components/buttons/BtnDefault";

/* ============================================
   MOCK DATA (sama dengan list page)
   ============================================ */
const MOCK_JOBDESK = [
  { id: 1, title: "Instalasi Baru - Pelanggan Paket 30 Mbps", assignee: "Ahmad Fauzi", department: "Teknisi", priority: "high", status: "in_progress", due_date: "2025-06-18T17:00:00", description: "Instalasi fiber optic ke rumah Bpk. Surya di Jl. Melati No. 15, RT 03/RW 07.", created_at: "2025-06-17T08:00:00" },
  { id: 2, title: "Perbaikan Koneksi - Gangguan Fiber Cut", assignee: "Rizky Pratama", department: "Teknisi", priority: "high", status: "in_progress", due_date: "2025-06-17T14:00:00", description: "Laporan gangguan dari area Perumahan Griya Asri, fiber putus akibat galian saluran.", created_at: "2025-06-17T09:30:00" },
  { id: 3, title: "Maintenance OLT - Firmware Update", assignee: "Dian Saputra", department: "Teknisi", priority: "medium", status: "pending", due_date: "2025-06-20T23:59:00", description: "Update firmware OLT Huawei MA5800-X7 ke versi terbaru untuk patch keamanan.", created_at: "2025-06-17T07:00:00" },
  { id: 4, title: "Input Data Stok Barang Masuk", assignee: "Siti Nurhaliza", department: "Gudang", priority: "medium", status: "in_progress", due_date: "2025-06-17T16:00:00", description: "Input 50 unit Router Mikrotik hEX S dan 100 meter Kabel UTP Cat6 ke sistem.", created_at: "2025-06-17T10:00:00" },
  { id: 5, title: "Penyusunan Laporan Bulanan Mei", assignee: "Budi Santoso", department: "Administrasi", priority: "low", status: "pending", due_date: "2025-06-25T17:00:00", description: "Menyusun laporan bulanan monitoring barang dan logistik bulan Mei 2025.", created_at: "2025-06-16T09:00:00" },
  { id: 6, title: "Survei Lokasi - Ekspansi Jaringan", assignee: "Ahmad Fauzi", department: "Teknisi", priority: "medium", status: "completed", due_date: "2025-06-16T17:00:00", description: "Survei lokasi untuk perluasan jaringan ke Perumahan Bumi Indah Blok C.", created_at: "2025-06-14T08:00:00" },
  { id: 7, title: "Pengadaan Kabel Fiber 24 Core", assignee: "Budi Santoso", department: "Administrasi", priority: "high", status: "pending", due_date: "2025-06-19T12:00:00", description: "Buat PO pengadaan 2000 meter kabel fiber optic 24 core ke supplier utama.", created_at: "2025-06-17T11:00:00" },
  { id: 8, title: "Handle Komplain Pelanggan - Speed Rendah", assignee: "Maya Putri", department: "CS", priority: "high", status: "in_progress", due_date: "2025-06-17T15:00:00", description: "Tiket #TK-20250617-003 dari pelanggan atas nama Ibu Ratna, speed hanya 5 Mbps dari 30 Mbps.", created_at: "2025-06-17T08:30:00" },
  { id: 9, title: "Stock Opname Gudang Cabang", assignee: "Siti Nurhaliza", department: "Gudang", priority: "medium", status: "pending", due_date: "2025-06-22T17:00:00", description: "Melakukan stock opname bulanan di gudang cabang Bandung dan mencocokkan dengan sistem.", created_at: "2025-06-15T09:00:00" },
  { id: 10, title: "Penggantian ONT Rusak - Pelanggan #1042", assignee: "Rizky Pratama", department: "Teknisi", priority: "low", status: "completed", due_date: "2025-06-16T14:00:00", description: "Ganti ONT ZTE F660 yang rusak di rumah pelanggan #1042 di Jl. Kenanga No. 8.", created_at: "2025-06-15T10:00:00" },
  { id: 14, title: "Perbaikan Tiang Penyangga Kabel", assignee: "Ahmad Fauzi", department: "Teknisi", priority: "high", status: "overdue", due_date: "2025-06-15T17:00:00", description: "Tiang penyangga kabel di Jl. Anggrek miring akibat angin kencang. Perlu segera diperbaiki.", created_at: "2025-06-13T11:00:00" },
  { id: 15, title: "Pembaruan Database Tarif Paket", assignee: "Hendra Wijaya", department: "Management", priority: "medium", status: "rejected", due_date: "2025-06-18T17:00:00", description: "Update harga paket internet sesuai keputusan rapat direksi tanggal 10 Juni 2025.", created_at: "2025-06-12T09:00:00" },
  { id: 16, title: "Pengelolaan Barang Rusak", assignee: "Siti Nurhaliza", department: "Gudang", priority: "low", status: "on_hold", due_date: "2025-06-20T17:00:00", description: "Klasifikasi dan proses disposal 5 unit CPE210 rusak dari hasil pemeriksaan berkala.", created_at: "2025-06-16T14:00:00" },
];

/* ============================================
   MOCK: Activity Log
   ============================================ */
const MOCK_ACTIVITIES = [
  { id: 1, action: "created", user: "Admin", detail: "Membuat tugas baru", timestamp: "2025-06-17T08:00:00" },
  { id: 2, action: "assigned", user: "Admin", detail: "Menugaskan ke Ahmad Fauzi", timestamp: "2025-06-17T08:01:00" },
  { id: 3, action: "status_change", user: "Ahmad Fauzi", detail: 'Status diubah ke "Diproses"', timestamp: "2025-06-17T09:15:00" },
  { id: 4, action: "comment", user: "Ahmad Fauzi", detail: "Sudah sampai lokasi, mulai pengecekan jalur fiber.", timestamp: "2025-06-17T10:30:00" },
];

/* ============================================
   KONFIGURASI STATUS & PRIORITY
   ============================================ */
const StatusConfig = {
  pending: { icon: <FaClock size={12} />, label: "Menunggu", bg: "rgba(100, 116, 139, 0.12)", border: "rgba(100, 116, 139, 0.2)", text: "#94a3b8", dotBg: "rgba(100, 116, 139, 0.35)", dotBorder: "rgba(100, 116, 139, 0.45)", fullBg: "bg-slate-500/10", fullBorder: "border-slate-500/20", fullText: "text-slate-400" },
  in_progress: { icon: <FaSpinner size={12} />, label: "Diproses", bg: "rgba(59, 130, 246, 0.1)", border: "rgba(59, 130, 246, 0.2)", text: "#60a5fa", dotBg: "rgba(59, 130, 246, 0.35)", dotBorder: "rgba(59, 130, 246, 0.45)", fullBg: "bg-blue-500/10", fullBorder: "border-blue-500/20", fullText: "text-blue-400" },
  completed: { icon: <FaCircleCheck size={12} />, label: "Selesai", bg: "rgba(16, 185, 129, 0.1)", border: "rgba(16, 185, 129, 0.2)", text: "#34d399", dotBg: "rgba(16, 185, 129, 0.35)", dotBorder: "rgba(16, 185, 129, 0.45)", fullBg: "bg-emerald-500/10", fullBorder: "border-emerald-500/20", fullText: "text-emerald-400" },
  on_hold: { icon: <FaCirclePause size={12} />, label: "Tertunda", bg: "rgba(245, 158, 11, 0.1)", border: "rgba(245, 158, 11, 0.2)", text: "#fbbf24", dotBg: "rgba(245, 158, 11, 0.35)", dotBorder: "rgba(245, 158, 11, 0.45)", fullBg: "bg-amber-500/10", fullBorder: "border-amber-500/20", fullText: "text-amber-400" },
  rejected: { icon: <FaCircleXmark size={12} />, label: "Ditolak", bg: "rgba(239, 68, 68, 0.08)", border: "rgba(239, 68, 68, 0.15)", text: "#f87171", dotBg: "rgba(239, 68, 68, 0.35)", dotBorder: "rgba(239, 68, 68, 0.45)", fullBg: "bg-red-500/8", fullBorder: "border-red-500/15", fullText: "text-red-400" },
  overdue: { icon: <FaFire size={12} />, label: "Terlambat", bg: "rgba(239, 68, 68, 0.12)", border: "rgba(239, 68, 68, 0.25)", text: "#f87171", dotBg: "rgba(239, 68, 68, 0.45)", dotBorder: "rgba(239, 68, 68, 0.55)", fullBg: "bg-red-500/10", fullBorder: "border-red-500/20", fullText: "text-red-400" },
};

const PriorityConfig = {
  high: { icon: <FaFire size={10} />, label: "Tinggi", bg: "rgba(239, 68, 68, 0.12)", border: "rgba(239, 68, 68, 0.22)", text: "#f87171" },
  medium: { icon: <FaArrowUpWideShort size={10} />, label: "Sedang", bg: "rgba(245, 158, 11, 0.1)", border: "rgba(245, 158, 11, 0.2)", text: "#fbbf24" },
  low: { icon: <FaArrowUpWideShort size={10} />, label: "Rendah", bg: "rgba(16, 185, 129, 0.1)", border: "rgba(16, 185, 129, 0.2)", text: "#34d399" },
};

const DepartmentConfig = {
  Teknisi: { color: "#60a5fa", bg: "rgba(59, 130, 246, 0.1)", border: "rgba(59, 130, 246, 0.2)" },
  Gudang: { color: "#fbbf24", bg: "rgba(245, 158, 11, 0.1)", border: "rgba(245, 158, 11, 0.2)" },
  Administrasi: { color: "#c084fc", bg: "rgba(168, 85, 247, 0.1)", border: "rgba(168, 85, 247, 0.2)" },
  CS: { color: "#34d399", bg: "rgba(16, 185, 129, 0.1)", border: "rgba(16, 185, 129, 0.2)" },
  Management: { color: "#fb923c", bg: "rgba(251, 146, 60, 0.1)", border: "rgba(251, 146, 60, 0.2)" },
};

const ActivityConfig = {
  created: { icon: <FaCirclePlay size={12} />, color: "#60a5fa", bg: "rgba(59, 130, 246, 0.1)", label: "Dibuat" },
  assigned: { icon: <FaUser size={12} />, color: "#c084fc", bg: "rgba(168, 85, 247, 0.1)", label: "Ditugaskan" },
  status_change: { icon: <FaCircleInfo size={12} />, color: "#fbbf24", bg: "rgba(245, 158, 11, 0.1)", label: "Status Diubah" },
  comment: { icon: <FaCommentDots size={12} />, color: "#34d399", bg: "rgba(16, 185, 129, 0.1)", label: "Komentar" },
};

/* ============================================
   HELPERS
   ============================================ */
const formatDateFull = (dateStr) => {
  return new Date(dateStr).toLocaleDateString("id-ID", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

const formatDateShort = (dateStr) => {
  return new Date(dateStr).toLocaleDateString("id-ID", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

const formatTime = (dateStr) => {
  return new Date(dateStr).toLocaleTimeString("id-ID", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

const formatDateTime = (dateStr) => {
  return `${formatDateShort(dateStr)}, ${formatTime(dateStr)}`;
};

const getDueInfo = (dueDate, status) => {
  const due = new Date(dueDate);
  const now = new Date();
  const diffMs = due - now;
  const diffHr = Math.floor(diffMs / 3600000);
  const diffDay = Math.floor(diffHr / 24);

  if (status === "completed" || status === "rejected") {
    return { label: "Selesai", sublabel: formatDateTime(dueDate), isOverdue: false, isUrgent: false };
  }

  if (diffHr < 0) {
    return {
      label: "Terlambat",
      sublabel: `${Math.abs(diffDay)} hari ${Math.abs(diffHr % 24)} jam lalu`,
      isOverdue: true,
      isUrgent: true,
    };
  }

  if (diffHr < 6) {
    return {
      label: "Sangat Segera",
      sublabel: `${diffHr} jam lagi`,
      isOverdue: false,
      isUrgent: true,
    };
  }

  if (diffHr < 24) {
    return {
      label: "Hari Ini",
      sublabel: `${diffHr} jam lagi`,
      isOverdue: false,
      isUrgent: true,
    };
  }

  if (diffDay < 3) {
    return {
      label: "Beberapa Hari Lagi",
      sublabel: `${diffDay} hari lagi`,
      isOverdue: false,
      isUrgent: false,
    };
  }

  return {
    label: `${diffDay} Hari Lagi`,
    sublabel: formatDateTime(dueDate),
    isOverdue: false,
    isUrgent: false,
  };
};

const getDuration = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = endDate ? new Date(endDate) : new Date();
  const diffHr = Math.floor((end - start) / 3600000);
  if (diffHr < 1) return "Kurang dari 1 jam";
  if (diffHr < 24) return `${diffHr} jam`;
  const diffDay = Math.floor(diffHr / 24);
  const remainHr = diffHr % 24;
  return remainHr > 0 ? `${diffDay} hari ${remainHr} jam` : `${diffDay} hari`;
};

/* ============================================
   KOMPONEN: Badges
   ============================================ */
const StatusBadge = ({ status, size = "sm" }) => {
  const cfg = StatusConfig[status] || StatusConfig.pending;
  const sizeClasses = size === "lg"
    ? "px-4 py-1.5 text-sm gap-2"
    : "px-2.5 py-1 text-xs gap-1.5";
  const iconSize = size === "lg" ? 14 : 12;
  const IconComponent = () => {
    if (status === "pending") return <FaClock size={iconSize} />;
    if (status === "in_progress") return <FaSpinner size={iconSize} className="animate-spin" />;
    if (status === "completed") return <FaCircleCheck size={iconSize} />;
    if (status === "on_hold") return <FaCirclePause size={iconSize} />;
    if (status === "rejected") return <FaCircleXmark size={iconSize} />;
    if (status === "overdue") return <FaFire size={iconSize} />;
    return <FaClock size={iconSize} />;
  };
  return (
    <span
      className={`inline-flex items-center font-semibold whitespace-nowrap ${sizeClasses}`}
      style={{
        background: cfg.bg,
        border: `1px solid ${cfg.border}`,
        color: cfg.text,
      }}
    >
      <IconComponent />
      {cfg.label}
    </span>
  );
};

const PriorityBadge = ({ priority }) => {
  const cfg = PriorityConfig[priority] || PriorityConfig.low;
  return (
    <span
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap"
      style={{ background: cfg.bg, border: `1px solid ${cfg.border}`, color: cfg.text }}
    >
      {cfg.icon}
      {cfg.label}
    </span>
  );
};

const DepartmentBadge = ({ dept }) => {
  const cfg = DepartmentConfig[dept] || { color: "#94a3b8", bg: "rgba(100,116,139,0.1)", border: "rgba(100,116,139,0.2)" };
  return (
    <span
      className="inline-flex px-2.5 py-0.5 text-xs font-semibold rounded-lg whitespace-nowrap"
      style={{ background: cfg.bg, border: `1px solid ${cfg.border}`, color: cfg.color }}
    >
      {dept}
    </span>
  );
};

/* ============================================
   KOMPONEN: Info Row (metadata detail)
   ============================================ */
const InfoRow = ({ icon, label, value, valueColor = "text-slate-200", children }) => (
  <div className="flex items-start gap-3 py-3" style={{ borderBottom: "1px solid rgba(51, 65, 85, 0.12)" }}>
    <div className="w-8 h-8 rounded-lg flex items-center justify-center shrink-0" style={{ background: "rgba(51, 65, 85, 0.25)", border: "1px solid rgba(51, 65, 85, 0.2)" }}>
      <span className="text-slate-500">{icon}</span>
    </div>
    <div className="flex-1 min-w-0">
      <p className="text-[11px] font-semibold text-slate-500 uppercase tracking-wider mb-0.5">{label}</p>
      {children ? children : <p className={`text-sm ${valueColor}`}>{value}</p>}
    </div>
  </div>
);

/* ============================================
   KOMPONEN: Activity Item
   ============================================ */
const ActivityItem = ({ activity, isLast }) => {
  const cfg = ActivityConfig[activity.action] || ActivityConfig.status_change;
  return (
    <div className="flex gap-3">
      {/* Timeline Line */}
      <div className="flex flex-col items-center">
        <div
          className="w-8 h-8 rounded-full flex items-center justify-center shrink-0 z-10"
          style={{ background: cfg.bg, border: `1px solid ${cfg.bg.replace("0.1", "0.2")}` }}
        >
          <span style={{ color: cfg.color }}>{cfg.icon}</span>
        </div>
        {!isLast && (
          <div className="w-px flex-1 my-1" style={{ background: "rgba(51, 65, 85, 0.3)" }} />
        )}
      </div>
      {/* Content */}
      <div className={`pb-5 ${isLast ? "pb-0" : ""}`}>
        <div className="flex items-center gap-2 mb-0.5">
          <span className="text-sm font-medium text-slate-300">{activity.user}</span>
          <span
            className="text-[10px] font-semibold px-1.5 py-0.5 rounded"
            style={{ background: cfg.bg, color: cfg.color }}
          >
            {cfg.label}
          </span>
        </div>
        <p className="text-sm text-slate-400 leading-relaxed">{activity.detail}</p>
        <p className="text-xs text-slate-600 mt-1">{formatDateTime(activity.timestamp)}</p>
      </div>
    </div>
  );
};

/* ============================================
   KOMPONEN: Status Change Dropdown
   ============================================ */
const StatusChangeDropdown = ({ currentStatus, onStatusChange }) => {
  const [open, setOpen] = useState(false);

  const availableStatuses = [
    { value: "pending", label: "Menunggu", icon: <FaClock size={12} />, color: "#94a3b8" },
    { value: "in_progress", label: "Mulai Proses", icon: <FaCirclePlay size={12} />, color: "#60a5fa" },
    { value: "on_hold", label: "Tunda", icon: <FaCirclePause size={12} />, color: "#fbbf24" },
    { value: "completed", label: "Tandai Selesai", icon: <FaSquareCheck size={12} />, color: "#34d399" },
    { value: "rejected", label: "Tolak", icon: <FaBan size={12} />, color: "#f87171" },
  ].filter((s) => s.value !== currentStatus);

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium text-cyan-400 border border-cyan-500/25 bg-cyan-500/8 hover:bg-cyan-500/15 transition-all"
      >
        <FaRotateLeft size={12} />
        Ubah Status
        <FaChevronDown size={10} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div
            className="absolute left-0 top-full mt-2 w-52 rounded-xl py-1.5 z-20 shadow-xl shadow-black/40"
            style={{
              background: "rgba(30, 41, 59, 0.95)",
              border: "1px solid rgba(51, 65, 85, 0.4)",
              backdropFilter: "blur(12px)",
            }}
          >
            {availableStatuses.map((s) => (
              <button
                key={s.value}
                onClick={() => {
                  onStatusChange(s.value);
                  setOpen(false);
                }}
                className="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm text-slate-300 hover:bg-slate-700/40 transition-all"
              >
                <span style={{ color: s.color }}>{s.icon}</span>
                {s.label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

/* ============================================
   KOMPONEN: Comment Input
   ============================================ */
const CommentInput = () => {
  const [comment, setComment] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!comment.trim()) return;
    // TODO: dispatch comment action
    console.log("Comment:", comment);
    setComment("");
  };

  return (
    <form onSubmit={handleSubmit} className="flex gap-3">
      <div className="w-8 h-8 rounded-lg flex items-center justify-center shrink-0 text-xs font-bold" style={{ background: "rgba(51, 65, 85, 0.3)", border: "1px solid rgba(51, 65, 85, 0.3)", color: "#94a3b8" }}>
        A
      </div>
      <div className="flex-1 relative">
        <textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Tulis komentar atau catatan..."
          rows={2}
          className="w-full px-4 py-2.5 text-sm rounded-xl bg-slate-800/60 border border-slate-600/40 text-gray-100 placeholder-slate-500 outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/20 transition-all resize-none"
        />
        <div className="flex items-center justify-between mt-2">
          <button type="button" className="text-slate-500 hover:text-slate-400 transition-colors">
            <FaPaperclip size={14} />
          </button>
          <button
            type="submit"
            disabled={!comment.trim()}
            className="px-4 py-1.5 rounded-lg text-xs font-semibold bg-cyan-600 text-white hover:bg-cyan-500 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
          >
            Kirim
          </button>
        </div>
      </div>
    </form>
  );
};

/* ============================================
   KOMPONEN: Skeleton Detail
   ============================================ */
const SkeletonDetail = () => (
  <main className="p-4 lg:p-6 space-y-5 animate-pulse">
    <div className="h-5 bg-slate-700/50 rounded-md w-48" />
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
      <div className="lg:col-span-2 space-y-4">
        <div className="rounded-2xl p-6" style={{ background: "rgba(15, 23, 42, 0.5)", border: "1px solid rgba(51, 65, 85, 0.3)" }}>
          <div className="h-6 bg-slate-700/60 rounded-md w-3/4 mb-4" />
          <div className="h-4 bg-slate-700/40 rounded-md w-full mb-2" />
          <div className="h-4 bg-slate-700/30 rounded-md w-2/3" />
        </div>
      </div>
      <div className="space-y-4">
        <div className="rounded-2xl p-5" style={{ background: "rgba(15, 23, 42, 0.5)", border: "1px solid rgba(51, 65, 85, 0.3)" }}>
          <div className="space-y-4">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="flex gap-3">
                <div className="w-8 h-8 rounded-lg bg-slate-700/40" />
                <div className="flex-1 space-y-1.5">
                  <div className="h-2.5 bg-slate-700/30 rounded w-16" />
                  <div className="h-3.5 bg-slate-700/50 rounded w-28" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </main>
);

/* ============================================
   SECTION CARD WRAPPER
   ============================================ */
const SectionCard = ({ title, icon, children, className = "" }) => (
  <div
    className={`rounded-2xl overflow-hidden ${className}`}
    style={{
      background: "rgba(15, 23, 42, 0.5)",
      border: "1px solid rgba(51, 65, 85, 0.3)",
    }}
  >
    <div
      className="px-5 py-3.5 flex items-center gap-2.5"
      style={{
        background: "rgba(15, 23, 42, 0.7)",
        borderBottom: "1px solid rgba(51, 65, 85, 0.2)",
      }}
    >
      <span className="text-slate-500">{icon}</span>
      <h3 className="text-sm font-bold text-slate-300 uppercase tracking-wider">{title}</h3>
    </div>
    <div className="p-5">{children}</div>
  </div>
);

/* ============================================
   MAIN: JobdeskDetailPage
   ============================================ */
export const JobdeskDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(false);
  const [loading, setLoading] = useState(true);

  // ✅ Simulasi fetch data
  useState(() => {
    setLoading(true);
    const t = setTimeout(() => setLoading(false), 600);
    return () => clearTimeout(t);
  });

  // ✅ Cari data berdasarkan ID
  const jobdesk = useMemo(() => {
    return MOCK_JOBDESK.find((item) => item.id === Number(id));
  }, [id]);

  // ✅ Hitung status overdue
  const displayStatus = useMemo(() => {
    if (!jobdesk) return "pending";
    if (jobdesk.status === "completed" || jobdesk.status === "rejected") return jobdesk.status;
    if (new Date(jobdesk.due_date) < new Date()) return "overdue";
    return jobdesk.status;
  }, [jobdesk]);

  // ✅ Due date info
  const dueInfo = useMemo(() => {
    if (!jobdesk) return { label: "-", sublabel: "-", isOverdue: false, isUrgent: false };
    return getDueInfo(jobdesk.due_date, jobdesk.status);
  }, [jobdesk]);

  // ✅ Progress bar calculation
  const progressPercent = useMemo(() => {
    if (!jobdesk) return 0;
    const map = { pending: 10, in_progress: 45, on_hold: 30, completed: 100, rejected: 0, overdue: 45 };
    return map[displayStatus] ?? 0;
  }, [jobdesk, displayStatus]);

  // ✅ 404 Handler
  if (!loading && !jobdesk) {
    return (
      <>
        <Helmet><title>Tugas Tidak Ditemukan - Radius Trend</title></Helmet>
        <DashboardLayout showSidebar={showSidebar} setShowSidebar={setShowSidebar}>
          <Header toggleSidebar={() => setShowSidebar(!showSidebar)}>
            <div className="flex items-center gap-3">
              <button
                onClick={() => navigate("/jobdesk")}
                className="p-2 rounded-lg text-slate-400 hover:text-gray-100 hover:bg-slate-700/40 transition-all"
              >
                <FaChevronLeft size={16} />
              </button>
              <h2 className="text-base md:text-xl font-bold text-gray-100">Detail Tugas</h2>
            </div>
          </Header>
          <main className="p-4 lg:p-6">
            <div className="rounded-2xl p-16 text-center" style={{ background: "rgba(15, 23, 42, 0.5)", border: "1px solid rgba(51, 65, 85, 0.3)" }}>
              <div className="w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-4" style={{ background: "rgba(51, 65, 85, 0.2)", border: "1px solid rgba(51, 65, 85, 0.2)" }}>
                <FaCircleXmark className="text-3xl text-slate-600" />
              </div>
              <h3 className="text-lg font-bold text-slate-400 mb-2">Tugas Tidak Ditemukan</h3>
              <p className="text-sm text-slate-500 mb-6">Tugas dengan ID #{id} tidak tersedia atau sudah dihapus.</p>
              <BtnDefault onClick={() => navigate("/jobdesk")}>
                Kembali ke Daftar Tugas
              </BtnDefault>
            </div>
          </main>
        </DashboardLayout>
      </>
    );
  }

  if (loading) {
    return (
      <>
        <Helmet><title>Memuat Detail... - Radius Trend</title></Helmet>
        <DashboardLayout showSidebar={showSidebar} setShowSidebar={setShowSidebar}>
          <Header toggleSidebar={() => setShowSidebar(!showSidebar)}>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-lg bg-slate-700/40 animate-pulse" />
              <div className="h-5 bg-slate-700/50 rounded-md w-48 animate-pulse" />
            </div>
          </Header>
          <SkeletonDetail />
        </DashboardLayout>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>{jobdesk.title} - Radius Trend</title>
        <meta name="description" content={`Detail tugas: ${jobdesk.title}`} />
      </Helmet>

      <DashboardLayout showSidebar={showSidebar} setShowSidebar={setShowSidebar}>
        {/* ===== Header ===== */}
        <Header toggleSidebar={() => setShowSidebar(!showSidebar)}>
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate("/jobdesk")}
              className="p-2 rounded-lg text-slate-400 hover:text-gray-100 hover:bg-slate-700/40 transition-all"
            >
              <FaChevronLeft size={16} />
            </button>
            <div className="hidden sm:block">
              <div className="flex items-center gap-2 text-xs text-slate-500 mb-0.5">
                <span className="hover:text-cyan-400 cursor-pointer transition-colors" onClick={() => navigate("/jobdesk")}>
                  Jobdesk
                </span>
                <FaChevronLeft size={8} />
                <span className="text-slate-400">Detail</span>
              </div>
              <h2 className="text-base md:text-xl font-bold text-gray-100 max-w-md truncate">
                {jobdesk.title}
              </h2>
            </div>
            <div className="sm:hidden">
              <h2 className="text-sm font-bold text-gray-100 max-w-[200px] truncate">
                {jobdesk.title}
              </h2>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <StatusChangeDropdown
              currentStatus={displayStatus}
              onStatusChange={(newStatus) => {
                // TODO: dispatch status change
                console.log("Change status to:", newStatus);
              }}
            />
            <BtnDefault
              onClick={() => {
                // TODO: open edit modal / navigate to edit
                console.log("Edit clicked");
              }}
            >
              <span className="hidden sm:flex items-center gap-2">
                <FaPenToSquare className="text-xs" />
                Edit
              </span>
              <FaPenToSquare className="sm:hidden" size={14} />
            </BtnDefault>
          </div>
        </Header>

        {/* ===== Content ===== */}
        <main className="p-4 lg:p-6 space-y-5">
          {/* ===== Overdue Alert ===== */}
          {dueInfo.isOverdue && (
            <div className="flex items-start gap-3 px-4 py-3.5 rounded-2xl bg-red-500/8 border border-red-500/20">
              <FaFire className="text-red-400 mt-0.5 shrink-0" size={16} />
              <div>
                <p className="text-sm font-bold text-red-300">Tugas Terlambat!</p>
                <p className="text-sm text-red-400/80 mt-0.5">
                  Batas waktu penyelesaian telah terlewat <span className="font-bold text-red-300">{dueInfo.sublabel}</span>. Segera tindak lanjuti.
                </p>
              </div>
            </div>
          )}

          {/* ===== Top: Badges & Quick Info ===== */}
          <div className="flex flex-wrap items-center gap-2">
            <StatusBadge status={displayStatus} size="lg" />
            <PriorityBadge priority={jobdesk.priority} />
            <DepartmentBadge dept={jobdesk.department} />
            {dueInfo.isUrgent && !dueInfo.isOverdue && (
              <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-amber-500/10 border border-amber-500/20 text-amber-400">
                <FaBell size={10} />
                Segera
              </span>
            )}
          </div>

          {/* ===== Main Grid ===== */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
            {/* ===== LEFT: Description & Activity ===== */}
            <div className="lg:col-span-2 space-y-5">
              {/* Deskripsi Tugas */}
              <SectionCard title="Deskripsi Tugas" icon={<FaCircleInfo size={14} />}>
                <p className="text-sm text-slate-300 leading-relaxed whitespace-pre-wrap">
                  {jobdesk.description}
                </p>
              </SectionCard>

              {/* Progress */}
              <SectionCard title="Progress" icon={<FaListCheck size={14} />}>
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-slate-400">Persentase Penyelesaian</span>
                    <span className={`text-sm font-bold ${displayStatus === "completed" ? "text-emerald-400" : displayStatus === "overdue" ? "text-red-400" : "text-cyan-400"}`}>
                      {progressPercent}%
                    </span>
                  </div>
                  <div className="w-full h-2.5 rounded-full overflow-hidden" style={{ background: "rgba(51, 65, 85, 0.3)" }}>
                    <div
                      className="h-full rounded-full transition-all duration-700 ease-out"
                      style={{
                        width: `${progressPercent}%`,
                        background:
                          displayStatus === "completed"
                            ? "linear-gradient(90deg, #059669, #34d399)"
                            : displayStatus === "overdue"
                            ? "linear-gradient(90deg, #dc2626, #f87171)"
                            : "linear-gradient(90deg, #0891b2, #22d3ee)",
                      }}
                    />
                  </div>
                  <div className="flex items-center gap-4 pt-1">
                    <div className="flex items-center gap-1.5">
                      <span className="w-2.5 h-2.5 rounded-full" style={{ background: "rgba(100, 116, 139, 0.4)", border: "1px solid rgba(100, 116, 139, 0.5)" }} />
                      <span className="text-xs text-slate-500">Menunggu</span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <span className="w-2.5 h-2.5 rounded-full" style={{ background: "rgba(59, 130, 246, 0.4)", border: "1px solid rgba(59, 130, 246, 0.5)" }} />
                      <span className="text-xs text-slate-500">Diproses</span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <span className="w-2.5 h-2.5 rounded-full" style={{ background: "rgba(16, 185, 129, 0.4)", border: "1px solid rgba(16, 185, 129, 0.5)" }} />
                      <span className="text-xs text-slate-500">Selesai</span>
                    </div>
                  </div>
                </div>
              </SectionCard>

              {/* Riwayat Aktivitas */}
              <SectionCard title="Riwayat Aktivitas" icon={<FaTimeline size={14} />}>
                <div className="space-y-0">
                  {MOCK_ACTIVITIES.map((activity, index) => (
                    <ActivityItem
                      key={activity.id}
                      activity={activity}
                      isLast={index === MOCK_ACTIVITIES.length - 1}
                    />
                  ))}
                </div>
              </SectionCard>

              {/* Komentar */}
              <SectionCard title="Komentar & Catatan" icon={<FaCommentDots size={14} />}>
                <div className="space-y-4">
                  {/* Existing Comment */}
                  <div className="flex gap-3 p-3 rounded-xl" style={{ background: "rgba(51, 65, 85, 0.1)" }}>
                    <div className="w-8 h-8 rounded-lg flex items-center justify-center shrink-0 text-xs font-bold" style={{ background: "rgba(59, 130, 246, 0.15)", border: "1px solid rgba(59, 130, 246, 0.25)", color: "#60a5fa" }}>
                      AF
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="text-sm font-medium text-slate-300">Ahmad Fauzi</span>
                        <span className="text-[10px] text-slate-600">{formatDateTime("2025-06-17T10:30:00")}</span>
                      </div>
                      <p className="text-sm text-slate-400 leading-relaxed">
                        Sudah sampai lokasi, mulai pengecekan jalur fiber. Kemungkinan perlu splicing 2 titik.
                      </p>
                    </div>
                  </div>

                  {/* Comment Input */}
                  <CommentInput />
                </div>
              </SectionCard>
            </div>

            {/* ===== RIGHT: Metadata Sidebar ===== */}
            <div className="space-y-5">
              {/* Informasi Tugas */}
              <SectionCard title="Informasi Tugas" icon={<FaHashtag size={14} />}>
                <div>
                  <InfoRow
                    icon={<FaHashtag size={13} />}
                    label="ID Tugas"
                    value={`#${String(jobdesk.id).padStart(4, "0")}`}
                    valueColor="text-cyan-400 font-mono"
                  />
                  <InfoRow
                    icon={<FaUser size={13} />}
                    label="Penanggung Jawab (PIC)"
                  >
                    <div className="flex items-center gap-2.5 mt-0.5">
                      <div
                        className="w-8 h-8 rounded-lg flex items-center justify-center text-xs font-bold shrink-0"
                        style={{
                          background: "rgba(51, 65, 85, 0.3)",
                          border: "1px solid rgba(51, 65, 85, 0.3)",
                          color: "#94a3b8",
                        }}
                      >
                        {jobdesk.assignee.charAt(0)}
                      </div>
                      <div>
                        <p className="text-sm font-medium text-slate-200">{jobdesk.assignee}</p>
                        <p className="text-xs text-slate-500">{jobdesk.department}</p>
                      </div>
                    </div>
                  </InfoRow>
                  <InfoRow
                    icon={<FaBuilding size={13} />}
                    label="Departemen"
                  >
                    <DepartmentBadge dept={jobdesk.department} />
                  </InfoRow>
                  <InfoRow
                    icon={<FaFlag size={13} />}
                    label="Prioritas"
                  >
                    <PriorityBadge priority={jobdesk.priority} />
                  </InfoRow>
                  <InfoRow
                    icon={<FaClock size={13} />}
                    label="Status Saat Ini"
                  >
                    <StatusBadge status={displayStatus} />
                  </InfoRow>
                </div>
              </SectionCard>

              {/* Waktu */}
              <SectionCard title="Waktu" icon={<FaCalendarDays size={14} />}>
                <div>
                  <InfoRow
                    icon={<FaCalendarDays size={13} />}
                    label="Tanggal Dibuat"
                    value={formatDateFull(jobdesk.created_at)}
                    valueColor="text-slate-300"
                  />
                  <InfoRow
                    icon={<FaClock size={13} />}
                    label="Waktu Dibuat"
                    value={formatTime(jobdesk.created_at)}
                    valueColor="text-slate-400"
                  />
                  <InfoRow
                    icon={<FaCalendarDays size={13} />}
                    label="Batas Tenggat"
                  >
                    <div>
                      <p className={`text-sm font-medium ${dueInfo.isOverdue ? "text-red-400" : "text-slate-200"}`}>
                        {formatDateFull(jobdesk.due_date)}
                      </p>
                      <p className="text-xs text-slate-500 mt-0.5">
                        Jam {formatTime(jobdesk.due_date)}
                      </p>
                    </div>
                  </InfoRow>
                  <InfoRow
                    icon={<FaBell size={13} />}
                    label="Sisa Waktu"
                  >
                    <span
                      className={`text-sm font-bold ${
                        dueInfo.isOverdue
                          ? "text-red-400"
                          : dueInfo.isUrgent
                          ? "text-amber-400"
                          : "text-emerald-400"
                      }`}
                    >
                      {dueInfo.label}
                    </span>
                    <p className={`text-xs mt-0.5 ${dueInfo.isOverdue ? "text-red-400/60" : "text-slate-500"}`}>
                      {dueInfo.sublabel}
                    </p>
                  </InfoRow>
                  {jobdesk.status === "completed" && (
                    <InfoRow
                      icon={<FaCircleCheck size={13} />}
                      label="Durasi Pengerjaan"
                      value={getDuration(jobdesk.created_at, new Date().toISOString())}
                      valueColor="text-emerald-400 font-medium"
                    />
                  )}
                  {displayStatus === "overdue" && (
                    <InfoRow
                      icon={<FaFire size={13} />}
                      label="Keterlambatan"
                      value={getDuration(jobdesk.due_date, null)}
                      valueColor="text-red-400 font-medium"
                    />
                  )}
                </div>
              </SectionCard>

              {/* Aksi Cepat */}
              <SectionCard title="Aksi Cepat" icon={<FaEllipsisVertical size={14} />}>
                <div className="space-y-2">
                  {displayStatus !== "completed" && displayStatus !== "rejected" && (
                    <button
                      onClick={() => console.log("Mark as completed")}
                      className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-emerald-400 border border-emerald-500/20 bg-emerald-500/5 hover:bg-emerald-500/15 transition-all"
                    >
                      <FaCircleCheck size={14} />
                      Tandai Selesai
                    </button>
                  )}
                  {displayStatus !== "on_hold" && displayStatus !== "completed" && displayStatus !== "rejected" && (
                    <button
                      onClick={() => console.log("Put on hold")}
                      className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-amber-400 border border-amber-500/20 bg-amber-500/5 hover:bg-amber-500/15 transition-all"
                    >
                      <FaCirclePause size={14} />
                      Tunda Sementara
                    </button>
                  )}
                  {displayStatus === "on_hold" && (
                    <button
                      onClick={() => console.log("Resume")}
                      className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-blue-400 border border-blue-500/20 bg-blue-500/5 hover:bg-blue-500/15 transition-all"
                    >
                      <FaCirclePlay size={14} />
                      Lanjutkan Tugas
                    </button>
                  )}
                  <button
                    onClick={() => console.log("Share")}
                    className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-slate-400 border border-slate-600/30 bg-slate-800/30 hover:bg-slate-700/40 hover:text-slate-200 transition-all"
                  >
                    <FaShareFromSquare size={14} />
                    Bagikan Tugas
                  </button>
                  <div style={{ borderTop: "1px solid rgba(51, 65, 85, 0.15)" }} className="!my-3" />
                  <button
                    onClick={() => console.log("Delete")}
                    className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-red-400 border border-red-500/15 bg-red-500/5 hover:bg-red-500/15 transition-all"
                  >
                    <FaTrashCan size={14} />
                    Hapus Tugas
                  </button>
                </div>
              </SectionCard>
            </div>
          </div>

          {/* ===== Mobile: Bottom Actions ===== */}
          <div className="lg:hidden sticky bottom-4 z-30">
            <div
              className="rounded-2xl p-3 flex items-center gap-2 shadow-xl shadow-black/30"
              style={{
                background: "rgba(15, 23, 42, 0.9)",
                border: "1px solid rgba(51, 65, 85, 0.4)",
                backdropFilter: "blur(16px)",
              }}
            >
              {displayStatus !== "completed" && displayStatus !== "rejected" && (
                <button
                  onClick={() => console.log("Mark completed")}
                  className="flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl text-sm font-semibold text-white bg-emerald-600 hover:bg-emerald-500 transition-all"
                >
                  <FaCircleCheck size={14} />
                  Selesai
                </button>
              )}
              <button
                onClick={() => console.log("Edit")}
                className="flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl text-sm font-medium text-cyan-400 border border-cyan-500/25 bg-cyan-500/8 hover:bg-cyan-500/15 transition-all"
              >
                <FaPenToSquare size={13} />
                Edit
              </button>
              <button
                onClick={() => console.log("More")}
                className="p-2.5 rounded-xl text-slate-400 border border-slate-600/30 bg-slate-800/30 hover:text-red-400 hover:border-red-500/20 hover:bg-red-500/5 transition-all"
              >
                <FaTrashCan size={14} />
              </button>
            </div>
          </div>

          {/* Spacer for mobile bottom bar */}
          <div className="h-20 lg:hidden" />
        </main>
      </DashboardLayout>
    </>
  );
};